import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../store/MSIdentity/thunks';
import { useHistory } from 'react-router-dom';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import Logo from '../../globals/images/Layout/logo3.svg';
import styles from './Login.module.scss';

const Login: React.FC = () => {
const dispatch = useDispatch<any>();
  const navigate = useHistory();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const messageResponse = useSelector((state: any) => state.system?.messageResponse);
  const isLoading = useSelector((state: any) => state.system?.loadingIndicator);

const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    const payload = { email, password };
    const result = await dispatch(login(payload) as any);
    if (result?.token) {
        navigate.push('/dashboard');
    }
};

  return (
    <div className={styles.wrap}>
      <div className={styles.card}>

        <div className={styles.logo}>
          <div className={styles.logoIcon}>
                <img src={Logo} alt="Glow Skin" />
          </div>
          <h1 className={styles.title}>Glow Skin</h1>
        </div>
        <form className={styles.form} onSubmit={handleLogin}>
          <label className={styles.label}>Correo electrónico</label>
          <input
            className={styles.input}
            type="email"
            placeholder="correo@ejemplo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />

          <label className={styles.label}>Contraseña</label>
          <div className={styles.passwordWrapper}>
            <input
              className={styles.input}
              type={showPassword ? 'text' : 'password'}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.eyeBtn}
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
                        {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}

            </button>
          </div>
              
          <a
            className={styles.forgot}
            href="/forgot-password"
            onClick={(e) => { e.preventDefault(); navigate.push('/forgot-password'); }}
          >
            ¿Olvidaste tu contraseña?
          </a>

          <button
            className={styles.btn}
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className={styles.spinner} />
            ) : (
              'Ingresar'
            )}
          </button>
        </form>
        <button
          className={styles.registerBtn}
          type="button"
          style={{ marginTop: '12px' }}
          onClick={() => navigate.push('/register')}
        >
          Crear una cuenta
        </button>

        <p className={styles.footer}>© 2026 Glow Skin · Todos los derechos reservados</p>
      </div>
    </div>
  );
};

export default Login;
